import { css } from '@emotion/react'
import common from 'shared/styles'

const styles = () => {
    return {
        reader: css`
            display: flex;
            justify-content: center;
            align-items: center;
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
            padding: 0;
        `,
        button: css`
            width: auto;
            margin: 50px 25px 50px 25px;
        `,
        icon: css`
            width: 50px;
            height: 50px;
        `,
    }
}

export default styles
